import { fromJS } from 'immutable'

export function loadState() {
  try {
    // try catch here because use privacy mode can disable local storage
    /*global localStorage*/
    const serializedState = localStorage.getItem('state')

    if (serializedState === null) {
      return undefined
    }

    return fromJS(JSON.parse(serializedState))
  } catch (err) {
    console.log(err)
    return undefined
  }
}

export function saveState(state) {
  try {
    const serializedState = JSON.stringify(state.toJS())
    /*global localStorage*/
    localStorage.setItem('state', serializedState)
  } catch (err) {
    console.log(err)
  }
}



// WEBPACK FOOTER //
// ./src/redux/state.js